import { render, staticRenderFns } from "./orderMonitor.vue?vue&type=template&id=071e87c8&scoped=true"
import script from "./orderMonitor.vue?vue&type=script&lang=js"
export * from "./orderMonitor.vue?vue&type=script&lang=js"
import style0 from "./orderMonitor.vue?vue&type=style&index=0&id=071e87c8&prod&scoped=true&lang=css"
import style1 from "./orderMonitor.vue?vue&type=style&index=1&id=071e87c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e87c8",
  null
  
)

export default component.exports